module.exports = __webpack_public_path__ + "static/media/chinese_02.2ba0c32b.jpg";